export type FinderModalStepStatus = 'done' | 'current' | 'pending' | 'visited';

export interface FinderModalStepDefinition {
  id: string;
  label: string;
  status: FinderModalStepStatus;
  number: number;
  isNavigable: boolean;
}

export function buildFinderModalSteps(input: {
  labels: string[];
  ids: string[];
  currentIndex: number;
  isResultStepComplete?: boolean;
  isStepAnswered?: (stepId: string) => boolean;
  allowDirectNavigation?: boolean;
}): FinderModalStepDefinition[] {
  const {
    labels,
    ids,
    currentIndex,
    isResultStepComplete = false,
    isStepAnswered,
    allowDirectNavigation = false
  } = input;

  return labels.map((label, index) => {
    const stepId = ids[index] ?? `step-${index}`;
    const isResultStep = stepId === 'result';
    const answered = isStepAnswered?.(stepId) ?? true;

    let status: FinderModalStepStatus;
    if (index < currentIndex) {
      status = answered ? 'done' : 'visited';
    } else if (index === currentIndex) {
      status = isResultStep && isResultStepComplete ? 'done' : 'current';
    } else {
      status = 'pending';
    }

    return {
      id: stepId,
      label,
      status,
      number: index + 1,
      isNavigable:
        (allowDirectNavigation && !isResultStep) || status !== 'pending'
    };
  });
}

export function getActiveFinderStepId(
  steps: FinderModalStepDefinition[]
): string {
  return (
    steps.find((step) => step.status === 'current')?.id ??
    steps[steps.length - 1]?.id ??
    ''
  );
}

export function getPreviousFinderStepId(
  steps: FinderModalStepDefinition[],
  activeStepId: string
): string | null {
  const currentIndex = steps.findIndex((step) => step.id === activeStepId);
  if (currentIndex <= 0) {
    return null;
  }
  return steps[currentIndex - 1]?.id ?? null;
}
